export enum EvalSortFields {
  Member = 'member',
  Date = 'date',
  Status = 'status',
  Manager = 'manager',
  Project = 'project',
  Location = 'location',
}
